module.exports = {"360222100":"浮梁镇","360222101":"鹅湖镇","360222102":"经公桥镇","360222103":"蛟潭镇","360222104":"湘湖镇","360222105":"瑶里镇","360222106":"洪源镇","360222107":"寿安镇","360222108":"三龙镇","360222109":"峙滩镇","360222200":"王港乡","360222201":"庄湾乡","360222203":"黄坛乡","360222204":"兴田乡","360222205":"江村乡","360222207":"勒功乡","360222208":"西湖乡","360222209":"罗家桥乡","360222400":"浮梁工业园区","360222500":"罗家垦殖场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360222.json
// module id = 1160
// module chunks = 0